import { BaseService, Service } from "/@/cool";
@Service("addPrintOrder")
class AddPrintOrder extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["add"] = prefix + "add";
		this.permission["update"] = prefix + "update";
		this.permission["page"] = prefix + "page";
		this.permission["list"] = prefix + "list";
		this.permission["info"] = prefix + "info";
		this.permission["orderInfo"] = prefix + "orderInfo";
		this.permission["updateAddress"] = prefix + "updateAddress";
	}

	orderInfo(params: any) {
		return this.request({
			url: "/orderInfo",
			method: "POST",
			params
		});
	}
	updateAddress(params: any) {
		return this.request({
			url: "/updateAddress",
			method: "POST",
			params
		});
	}
}
export default AddPrintOrder;
